//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';
import { Box, CircularProgress, Paper, Typography } from '@mui/material';

// === COMPONENTS ===
import { HeaderTaskView } from './components/HeaderTaskView/HeaderTaskView';
import Styled from 'components/Styled/Styled';

// === API ===
import { clearFocus, on, removeListener, requestDocumentRuleTasks } from 'api/prokey/prokey.websocket';
import { LayoutProvider } from 'pages/FileViewer/components/Panel/PanelContext';
import { Panel } from 'pages/FileViewer/components/Panel';
import { DropProvider } from 'components/DragDrop/DropContext';
import { useAnalytics } from '../AnalyticsContext/AnalyticsContext';

//#endregion

//-----------------------------------------------------------------
export function TaskView( ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { file_id } = useParams();
  const  [searchParams] = useSearchParams()

  const theme = useTheme();

  const { task, clearTask, document_current } = useAnalytics();

  const _styles = {
    container: {
      width: `100%`,
      height: `calc( 100% - 60px )`,
      padding: '10px',
      zIndex: '0',
      gridGap: '1rem',
      background: theme.palette.background.secondary[theme.palette.mode],
    },
    spinner_box: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      height: '14rem',
      width: '10rem',
      textAlign: 'center'
    },
    spinner: {
      margin: '2rem',
    },
    spinner_caption: {},
  };

  //#endregion

  //#region [PROCES]

  useEffect(() => {
    const document = searchParams.get( 'document' );
    requestDocumentRuleTasks( file_id , document );

    return () => {
      clearFocus();
      clearTask();
    };
  }, []); // empty dependency = called only once at startup

  useEffect( () => {
    if( ['', task?.numcode].includes(document_current) ) return;

    requestDocumentRuleTasks( file_id , document_current );
  }, [document_current] );

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function dislpay() {
    //-----------------------------------------------------------------
    let body = null;

    if(!task || task?.numcode !== document_current) {
      body = (
        <>
          <Paper sx={_styles.spinner_box}>
            <CircularProgress sx={_styles.spinner} size='6rem' />
            <Typography variant='button' sx={_styles.spinner_caption} display='block'>
              Loading Document
            </Typography>
          </Paper>
        </>
      );
    } else if( task.rules.order.length > 0 ) {
      body = (
        <DropProvider>
          <Panel id={1} />
        </DropProvider>
      )
    } else {
      body = (
        <Styled styles={[
            { display: 'flex', height: '54px' },
            { alignItems: 'center', justifyContent: 'center' },
          ]}>
          <Styled styles={[
            { display: 'flex', width: 'fit-content' },
            { fontSize: 20 },
            { padding: '12px' },
            { borderRadius: '10px' },
            { background: theme.palette.background.primary[theme.palette.mode] },
          ]}>
            No rules have been evaluated for this document.
          </Styled>
        </Styled>
      )
    }

    return (
      <>
        <HeaderTaskView />
        <LayoutProvider name='layout-analytics' >
          <Box sx={_styles.container}>
            { body }
          </Box>
        </LayoutProvider>
      </>
    );
  }
  //#endregion

  return dislpay();
}